import React from "react";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
import Icon from "../components/Icon";

export default function OpenSollicitatie() {
    return (
        <>
            <Helmet>
                <title>Open sollicitatie - Werken bij Smith</title>
                <meta
                    name="description"
                    content="Geen passende vacature gevonden? Lees hoe je een open sollicitatie stuurt naar Smith Solar en Smith Tuinbouwtechniek en vertel ons over jouw talent."
                />
            </Helmet>
            <section className="job-header">
                <div className="site-container">
                    <Link to="/#vacatures" className="back-link">
                        <Icon /> Alle vacatures
                    </Link>
                    <span className="eyebrow">JOUW TALENT IS WELKOM</span>
                    <h1>Open sollicitatie</h1>
                    <p>
                        Jouw baan nog niet gevonden? Laat ons weten waar jij
                        energie van krijgt.
                    </p>
                </div>
            </section>
            <article className="container container-sm job-article">
                <h2>Maak kennis met Smith</h2>
                <p>
                    Zie je jezelf werken bij Smith Solar of Smith
                    Tuinbouwtechniek, maar staat er geen passende vacature
                    tussen? Met een open sollicitatie vertel je ons wie je bent
                    en wat je graag wilt doen. Zo kunnen we kijken of jouw
                    talent aansluit bij de mogelijkheden binnen ons team.
                </p>
                <h2>Hoe werkt een open sollicitatie?</h2>
                <ol className="application-steps">
                    <li>
                        <h3>Vertel ons over jezelf</h3>
                        <p>
                            Schrijf een korte motivatie: waarom wil je bij Smith
                            werken, waar ben je goed in en wat voor werk zoek
                            je? Geef ook aan hoeveel uur je wilt werken en
                            wanneer je beschikbaar bent.
                        </p>
                    </li>
                    <li>
                        <h3>Stuur je motivatie en cv</h3>
                        <p>
                            Mail je sollicitatie naar{" "}
                            <a href="mailto:hr@smithtechniek.nl?subject=Open%20sollicitatie">
                                hr@smithtechniek.nl
                            </a>{" "}
                            met als onderwerp ‘Open sollicitatie’. Voeg je cv
                            toe en vermeld hoe we je kunnen bereiken. Je mag
                            aangeven of je interesse hebt in Smith Solar, Smith
                            Tuinbouwtechniek of allebei.
                        </p>
                    </li>
                    <li>
                        <h3>Verken samen de mogelijkheden</h3>
                        <p>
                            Een open sollicitatie is een kennismaking zonder
                            specifieke vacature. Zien we een mogelijke match,
                            dan nemen we contact met je op om verder te praten
                            over jouw wensen, ervaring en de mogelijkheden bij
                            Smith.
                        </p>
                    </li>
                </ol>
                <aside className="job-contact">
                    <span className="eyebrow">KLAAR VOOR DE EERSTE STAP?</span>
                    <h2>We horen graag van je.</h2>
                    <p>
                        Stuur je cv en motivatie naar hr@smithtechniek.nl. Heb
                        je eerst een vraag? Die kun je ook op dit adres stellen.
                    </p>
                    <a
                        className="button button-orange"
                        href="mailto:hr@smithtechniek.nl?subject=Open%20sollicitatie"
                    >
                        Stuur je open sollicitatie <Icon name="mail" />
                    </a>
                    <Link to="/#vacatures" className="text-link">
                        Bekijk de vacatures <Icon />
                    </Link>
                </aside>
            </article>
        </>
    );
}
